// removed by extract-text-webpack-plugin
module.exports = {"betBothButton":"_3CZuHDFXYNPBwPEOPVQ6OF","container":"oBtquA-dzy2gxYjsek8QE","arrowRight":"DdpKJw8FGaMdD-zjQmsTM","arrowLeft":"_1nrsb6eWVD_AmFq__g_f7D","marketText":"FFBzFT5ECJxuX4b3LjRBB","marketType":"_1tTRMD3nh5-XCb6vFMuYH8","wrapper":"hO7cYrb7AwTtgkKIEr8p1","disabled":"_1hXFNqHJhWNoKlyO8WJqKP","disabledArrowLeft":"_1hWVVoPYGZr2orwyERkNPw","disabledArrowRight":"_3az4SDiX1w3jbsJ8OR5Qhy","disabledContainer":"_3ssynGdYU4AkEg3-svz9dA","buttonCustomStyle":"LgSD36g_LUsdq2n6FndoG"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/matchday/css/betBothCard.css
// module id = 862
// module chunks = 0